import * as types from '../constants/actionTypes';

export const actions = {

    handleWindowResize: (width) => {
        return {
            type: types.HANDLE_WINDOW_RESIZE,
            width: width
        };
    }
}
